/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react-redux
import { useSelector, useDispatch } from 'react-redux';

// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";

// actions

import { getPastChecklists, createCalendarEvents} from 'actions/checklistActions.js';

// core components
import CardsHeader from "components/Headers/CardsHeader.js";
import Calendar from "../calendar/Calendar";
import Loading from 'components/Misc/Loading.js'
import ProInvitation from 'components/Misc/ProInvitation'

function ChecklistsCalendar() {
  const dispatch = useDispatch();
  const filterState = useSelector(state => state.filter);
  const checklistsState = useSelector(state => state.checklists);
  const userState = useSelector(state => state.user);
  const [renderKey, setRenderKey] = React.useState(0);

  React.useEffect(async () => {
    if (filterState.filter.address && ((userState.user.role === 'owner' && userState.user.plan !== 'free') || userState.user.role !== 'owner')) {
      await dispatch(getPastChecklists());
      await dispatch(createCalendarEvents());
      setRenderKey(prevState => prevState += 1);
    }
  }, [
    filterState.filter.address,
  ]);

  if (userState.user.role === 'owner' && userState.user.plan === 'free') {
    return (
      <ProInvitation proFeature={'calendar'}/>
    )
  }

  if (!filterState.filter.address) {
    return (
      <>
        <CardsHeader name="" parentName="ChecklistsCalendars" />
        <Container className="mt-5" fluid>
          <Row className="justify-content-center">
            <Col lg="5" md="7">
              <Card className="bg-secondary border-0 mb-0">
                <CardHeader className="pb-5" style={{backgroundColor: 'rgba(190, 5, 39, 1)'}}>
                  <div className="text-center mt-2 mb-3">
                    <h3 className='text-white'>Please select a specific location.</h3>
                  </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-5">
                  <div className="text-center mb-4">
                    <p>Select the address of the location you would like to see the calendar for on the left navbar.</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }

  if (!checklistsState.calendar) {
    return <Loading active={true} />;
  }

  return (
    <>
      <CardsHeader name="" parentName="ChecklistsCalendars" />
      <Container className="mt-5" fluid>
        <Row>
          <Col xl="12">
            <Calendar key={renderKey} eventsVariables={checklistsState.calendar} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ChecklistsCalendar;
